import { createNadDebug } from '../../../utils/debugLog'
import type { CheckoutEvent } from '../portable'

const checkoutLog = createNadDebug('dw:checkout-client:lifecycle')

export function recordDreamwriteCheckoutEvent(event: CheckoutEvent): void {
  checkoutLog({
    event: `checkout-client:${event.type}`,
    ...(event.type === 'checkout_failed'
      ? { phase: event.phase, error_code: event.code }
      : {}),
  })
}
